import OriginalTippy from '@tippyjs/react';
import PropTypes from 'prop-types';
import React from 'react';
import TippyBase from './tippy-base';
import TippyPopper from './tippy-popper';
import TippyTooltip from './tippy-tooltip';

const Tippy = React.forwardRef((props, ref) => {
  const { theme, ...otherProps } = props;
  let Component = OriginalTippy;

  if (theme === 'base') {
    Component = TippyBase;
  }
  if (theme === 'popper') {
    Component = TippyPopper;
  }
  if (theme === 'tooltip') {
    Component = TippyTooltip;
  }

  return <Component {...otherProps} ref={ref} theme={theme} />;
});

Tippy.propTypes = {
  theme: PropTypes.string,
};

export default Tippy;
